<template>
    <el-dialog :title="EditDalogType == 'edit' ? '编辑' : '查看报价'" :visible.sync="FeeFileConfigureAddDalogFlag"
        :destroy-on-close="true" width="60%" top="70px" style="text-align: center">
        <el-form ref="addServicesForm" :model="addForm" label-width="60px">
            <el-form-item class="EditDalogDaterange" label="有效期" prop="warehouseId">
                <el-date-picker v-model="addForm.daterange" type="daterange" :clearable="false" range-separator='至'
                    start-placeholder='开始日期' :disabled="EditDalogType != 'edit'" end-placeholder='结束日期'
                    value-format='yyyy-MM-dd'>
                </el-date-picker>
            </el-form-item>
        </el-form>
        <el-table border :data="tableData" ref="table" :empty-text="'暂无数据'" style="width: 100%;">
            <el-table-column prop="feeItemName" label="费用项" align="center">
            </el-table-column>
            <el-table-column prop="feeUnit" label="计费单位" align="center">
            </el-table-column>
            <el-table-column prop="currency" label="币种" width="150" align="center">
            </el-table-column>
            <el-table-column prop="unitPrice" label="单价" width="150" align="center">
            </el-table-column>
            <el-table-column prop="minValue" label="区间起" width="150" align="center">
            </el-table-column>
            <el-table-column prop="maxValue" label="区间止" width="150" align="center">
            </el-table-column>
            <el-table-column v-if="EditDalogType == 'edit'" label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="outerFotter" v-if="EditDalogType == 'edit'">
            <el-button type="primary" @click="onSubmit" :loading="addLoading">确认提交</el-button>
            <el-button @click.native="FeeFileConfigureAddDalogFlag = false" :loading="addLoading">取消</el-button>
        </div>
        <el-dialog title="编辑" :visible.sync="editFlag" :destroy-on-close="true" width="25%" top="100px" append-to-body
            style="text-align: center">
            <el-form ref="editForm" :model="editForm" :rules="formRules" label-width="80px">
                <el-form-item label="费用项" prop="feeItemName">
                    <el-input v-model="editForm.feeItemName" disabled></el-input>
                </el-form-item>
                <el-form-item label="计费单位" prop="feeUnit">
                    <el-input v-model="editForm.feeUnit" disabled></el-input>
                </el-form-item>
                <span v-if="editForm.feeItemName === '存储费'">
                    <el-form-item label="区间起" prop="minValue">
                        <el-input v-model="editForm.minValue" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="区间止" prop="maxValue">
                        <el-input v-model="editForm.maxValue" type="number"></el-input>
                    </el-form-item>
                </span>
                <el-form-item label="币种" prop="currency">
                    <el-select v-model="editForm.currency" placeholder="请选择币种" style="width: 100%">
                        <el-option v-for="item in currencyList" :label="item.label" :value="item.value"
                            :key="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="金额" prop="unitPrice">
                    <el-input v-model="editForm.unitPrice" type="number"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveToTable" :loading="addLoading">保存</el-button>
                    <el-button @click.native="editFlag = false" :loading="addLoading">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-dialog>
</template>
  
<script>
import {
    ImportFeeFile,
    UpdateFeeFileData,
    AddServices
} from "@/api/costManagement/FeeFileConfigure.js";
import { GetCurrencyServiceModelList } from "@/api/common/common.js";
import { urlEncode, deleteJsonEmptyProps, toSelectOptions } from "util/util";
export default {
    props: ['warehouseList', 'customList', 'EditDalogType'],
    data() {
        return {
            editFlag: false,
            currencyList: [],
            editIndex: 0, // 修改表格下标
            editForm: {},
            expensesList: [],
            tableData: [],
            fileList: [],
            addForm: {},
            FeeFileConfigureAddDalogFlag: false,
            addLoading: false,
            formRules: {
                feeItemName: [{ required: true, message: "请输入客户货主", trigger: "blur" }],
                feeUnit: [{ required: true, message: "请选择计费单位", trigger: "blur" }],
                minValue: [{ required: true, message: "请输入区间起", trigger: "blur" }],
                maxValue: [{ required: true, message: "请输入区间止", trigger: "blur" }],
                currency: [{ required: true, message: "请选择币种", trigger: "blur" }],
                unitPrice: [{ required: true, message: "请输入金额", trigger: "blur" }],
            }
        };
    },
    methods: {
        // 更新表格数据
        saveToTable() {
            let newTableRow = {
                ...this.tableData[this.editIndex],
                ...this.editForm
            }
            this.$set(this.tableData, this.editIndex, newTableRow)
            this.editFlag = false
        },
        // 编辑表格某行
        handleClick(index, rowData) {
            this.editIndex = index
            let { feeUnit, currency, unitPrice, minValue, maxValue, feeItemName } = rowData
            this.editForm = {
                feeUnit, currency, unitPrice, minValue, maxValue, feeItemName
            }
            this.editFlag = true
        },
        // 显示外层弹窗
        showDalog(data) {
            this.addForm = {
                daterange: [data.effectiveDateDesc, data.expirationDateDesc],
                ...data
            }
            this.tableData = data.detailList || []
            this.FeeFileConfigureAddDalogFlag = true;
        },
        onSubmit() {
            this.$refs.addServicesForm.validate((valid) => {
                if (valid) {
                    let params = {
                        ...this.addForm,
                        effectiveDate: this.addForm.daterange[0],
                        expirationDate: this.addForm.daterange[1],
                        detailList: this.tableData
                    }
                    this.addLoading = true;
                    UpdateFeeFileData(params).then((res) => {
                        this.addLoading = false;
                        if (res.data.success) {
                            this.$refs["addServicesForm"].resetFields();
                            this.$message({
                                message: res.data.msg || "操作成功",
                                type: "success",
                            });
                            this.FeeFileConfigureAddDalogFlag = false;
                            this.$emit("searchTable", "");
                        } else {
                            this.$message({
                                message: res.data.msg || "操作失败",
                                type: "error",
                            });
                        }
                    })
                }
            });
        },

    },
    mounted() {
        let para = {};
        GetCurrencyServiceModelList(para).then((res) => {
            this.currencyList = toSelectOptions(res.data.response, 'currencyValue', 'currencyName')
        });
    },
};
</script>

<style lang="less" scoped>
.outerFotter {
    margin-top: 20px;
}

.EditDalogDaterange {
    ::v-deep .el-form-item__content {
        text-align: left;
    }
}

.editDaterangeBtn {
    margin-left: 10px;
}
</style>
  
  